export const convertMinutesToHoursAndMinutes = (minutes) => {
    const checkMinutes = Math.abs(minutes);
    const hours = Math.floor(checkMinutes / 60);
    const remainingMinutes = checkMinutes % 60;

    return hours < 0 ? `${minutes < 0 ? '-' : ''}${hours} hr` : `${minutes < 0 ? '-' : ''}${hours} hr ${remainingMinutes} min`;
};